<header class="headerBg col-12 pl-xl-5 pr-xl-5 pl-lg-5 pr-lg-5 pl-sm-3 pr-sm-3">

  <div class="subHeaderBackBtn" *ngIf="showButton" (click)="backClick()">
    <img src="assets/images/calendar-arrow-right.svg" style="transform: rotate(180deg);">
    <p>{{backButton.title}}</p>
  </div>

  <h1 class="col-12 p-0">{{ heading }}</h1>

</header>



// WEBPACK FOOTER //
// ./src/app/template/subheader/subheader.component.html